import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import ScrollAnimation from '../../components/base/ScrollAnimation';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';
import { useSEO, generateServiceSchema, generateBreadcrumbSchema, generateFAQSchema } from '../../utils/seo';

export default function MobileTintingPage() {
  const faqs = [
    {
      question: 'What areas do you serve for mobile tinting?',
      answer: 'We serve Baltimore and surrounding areas including Glen Burnie, Towson, Columbia, Ellicott City, Catonsville, and more. We also offer mobile service for fleet tinting across Maryland. Additional travel fees may apply for locations outside Baltimore County.',
    },
    {
      question: 'Is mobile tinting the same quality as in-shop service?',
      answer: 'Absolutely! We use the same premium materials and professional equipment for mobile installations. You get the same lifetime warranty and expert installation, just at your convenient location.',
    },
    {
      question: 'How long does mobile window tinting take?',
      answer: 'Most vehicles take 2-4 hours for complete installation. We bring all necessary equipment and work efficiently at your location while you handle your day.',
    },
    {
      question: 'Do you offer other mobile services besides window tinting?',
      answer: 'Yes! We also offer mobile headlight and taillight tinting, and vehicle decals installation. Contact us to discuss your specific needs and we can bring our services to you.',
    },
    {
      question: 'What do I need to provide for mobile service?',
      answer: 'We just need access to your vehicle and a shaded area if possible (garage, carport, or covered area). We bring all equipment, materials, and supplies needed for professional installation.',
    },
    {
      question: 'Can you tint multiple vehicles at once?',
      answer: 'Yes! We specialize in fleet services and can handle multiple vehicles efficiently. This is perfect for businesses looking to tint their entire fleet. We offer volume discounts and flexible scheduling.',
    },
    {
      question: 'What if it rains on the day of my mobile appointment?',
      answer: 'We need a covered area for installation. If you have a garage or carport, we can proceed. Otherwise, we can reschedule or you can visit our shop for the same quality service and warranty.',
    },
    {
      question: 'Do you offer commercial tinting at business locations?',
      answer: 'Yes! We provide commercial window tinting for offices, storefronts, and buildings. We can come to your business location for consultation and installation. Learn more on our commercial tinting page.',
    },
  ];

  useSEO({
    title: 'Mobile Window Tinting Baltimore - We Come to You | U.B.K Window Tint',
    description: 'Mobile window tinting service in Baltimore, MD. Professional installation at your home or office. Same quality and lifetime warranty. Serving Baltimore County. Call (443) 800-0348.',
    keywords: 'mobile window tinting Baltimore, on-site tinting, mobile service Maryland, fleet tinting, convenient window tint',
    canonical: '/mobile-tinting',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          ...generateServiceSchema(
            'Mobile Window Tinting',
            'Professional mobile window tinting service. We come to your location with full equipment. Same quality and warranty as in-shop service.',
            '/mobile-tinting'
          ),
          areaServed: [
            { '@type': 'City', name: 'Baltimore' },
            { '@type': 'City', name: 'Glen Burnie' },
            { '@type': 'City', name: 'Towson' },
            { '@type': 'City', name: 'Columbia' },
            { '@type': 'City', name: 'Ellicott City' },
            { '@type': 'City', name: 'Catonsville' },
            { '@type': 'City', name: 'Dundalk' },
            { '@type': 'City', name: 'Essex' },
            { '@type': 'City', name: 'Parkville' },
            { '@type': 'City', name: 'Owings Mills' },
            { '@type': 'City', name: 'Reisterstown' },
            { '@type': 'City', name: 'Pikesville' },
            { '@type': 'City', name: 'Severna Park' },
            { '@type': 'PostalCodeRange', postalCode: '21201' },
            { '@type': 'PostalCodeRange', postalCode: '21202' },
            { '@type': 'PostalCodeRange', postalCode: '21205' },
            { '@type': 'PostalCodeRange', postalCode: '21206' },
            { '@type': 'PostalCodeRange', postalCode: '21207' },
            { '@type': 'PostalCodeRange', postalCode: '21208' },
            { '@type': 'PostalCodeRange', postalCode: '21209' },
            { '@type': 'PostalCodeRange', postalCode: '21210' },
            { '@type': 'PostalCodeRange', postalCode: '21211' },
            { '@type': 'PostalCodeRange', postalCode: '21212' },
            { '@type': 'PostalCodeRange', postalCode: '21213' },
            { '@type': 'PostalCodeRange', postalCode: '21214' },
            { '@type': 'PostalCodeRange', postalCode: '21215' },
            { '@type': 'PostalCodeRange', postalCode: '21216' },
            { '@type': 'PostalCodeRange', postalCode: '21217' },
            { '@type': 'PostalCodeRange', postalCode: '21218' },
            { '@type': 'PostalCodeRange', postalCode: '21219' },
            { '@type': 'PostalCodeRange', postalCode: '21220' },
            { '@type': 'PostalCodeRange', postalCode: '21221' },
            { '@type': 'PostalCodeRange', postalCode: '21222' },
            { '@type': 'PostalCodeRange', postalCode: '21223' },
            { '@type': 'PostalCodeRange', postalCode: '21224' },
            { '@type': 'PostalCodeRange', postalCode: '21225' },
            { '@type': 'PostalCodeRange', postalCode: '21226' },
            { '@type': 'PostalCodeRange', postalCode: '21227' },
            { '@type': 'PostalCodeRange', postalCode: '21228' },
            { '@type': 'PostalCodeRange', postalCode: '21229' },
            { '@type': 'PostalCodeRange', postalCode: '21230' },
            { '@type': 'PostalCodeRange', postalCode: '21231' },
            { '@type': 'PostalCodeRange', postalCode: '21234' },
            { '@type': 'PostalCodeRange', postalCode: '21236' },
            { '@type': 'PostalCodeRange', postalCode: '21237' },
            { '@type': 'PostalCodeRange', postalCode: '21239' },
            { '@type': 'PostalCodeRange', postalCode: '21244' },
            { '@type': 'PostalCodeRange', postalCode: '21250' },
            { '@type': 'PostalCodeRange', postalCode: '21251' },
            { '@type': 'PostalCodeRange', postalCode: '21252' },
            { '@type': 'PostalCodeRange', postalCode: '21061' },
            { '@type': 'PostalCodeRange', postalCode: '21060' },
            { '@type': 'PostalCodeRange', postalCode: '21122' },
            { '@type': 'PostalCodeRange', postalCode: '21146' },
            { '@type': 'PostalCodeRange', postalCode: '21401' },
            { '@type': 'PostalCodeRange', postalCode: '21403' },
            { '@type': 'PostalCodeRange', postalCode: '21012' },
            { '@type': 'PostalCodeRange', postalCode: '21113' },
            { '@type': 'PostalCodeRange', postalCode: '21144' },
            { '@type': 'PostalCodeRange', postalCode: '21045' },
            { '@type': 'PostalCodeRange', postalCode: '21042' },
            { '@type': 'PostalCodeRange', postalCode: '21043' },
            { '@type': 'PostalCodeRange', postalCode: '21044' },
            { '@type': 'PostalCodeRange', postalCode: '21117' },
            { '@type': 'PostalCodeRange', postalCode: '21133' },
            { '@type': 'PostalCodeRange', postalCode: '21136' },
          ],
        },
        generateFAQSchema(faqs),
        generateBreadcrumbSchema([
          { name: 'Home', url: '/' },
          { name: 'Mobile Tinting', url: '/mobile-tinting' },
        ]),
      ],
    },
  });

  const benefits = [
    {
      icon: 'ri-home-line',
      title: 'At Your Location',
      description: 'We come to your home, office, or any convenient location in Baltimore and surrounding areas.',
    },
    {
      icon: 'ri-time-line',
      title: 'Save Time',
      description: 'No need to drive to a shop or wait around. We work while you handle your day.',
    },
    {
      icon: 'ri-tools-line',
      title: 'Full Equipment',
      description: 'Our mobile unit has all professional tools and materials for perfect installation.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Same Quality',
      description: 'Identical quality and warranty as in-shop service. No compromises on excellence.',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Flexible Scheduling',
      description: 'Book appointments that fit your schedule, including evenings and weekends.',
    },
    {
      icon: 'ri-team-line',
      title: 'Fleet Services',
      description: 'Perfect for businesses with multiple vehicles. We handle entire fleets efficiently.',
    },
  ];

  const serviceAreas = [
    'Baltimore City',
    'Glen Burnie',
    'Towson',
    'Columbia',
    'Ellicott City',
    'Catonsville',
    'Dundalk',
    'Essex',
    'Parkville',
    'Owings Mills',
    'Reisterstown',
    'Pikesville',
  ];

  return (
    <div className="min-h-screen">
      <Navigation />
      <main className="pt-24 max-md:pt-20">
        {/* Hero Section */}
        <section className="relative pt-12 md:pt-16 pb-8 md:pb-12 bg-gradient-to-br from-secondary via-gray-800 to-secondary overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
              backgroundSize: '50px 50px',
            }}></div>
          </div>
          
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 items-center">
              <div className="text-white">
                <div className="inline-block bg-accent text-white px-3 md:px-4 py-1 md:py-2 rounded-full font-semibold mb-2 md:mb-4 text-xs md:text-base">
                  <i className="ri-map-pin-user-line mr-1 md:mr-2"></i>
                  Mobile Service Available
                </div>
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-3 md:mb-6 leading-tight">
                  We Come to You
                </h1>
                <p className="text-sm md:text-xl text-gray-300 mb-4 md:mb-8 leading-relaxed">
                  Professional window tinting at your location. No shop visit required. Same premium quality and lifetime warranty, delivered to your doorstep.
                </p>
                <div className="flex flex-col sm:flex-row gap-2 md:gap-4">
                  <Link to="/contact">
                    <Button size="lg" className="text-xs md:text-base py-2 md:py-3 px-4 md:px-6">
                      <i className="ri-calendar-line mr-1 md:mr-2"></i>
                      Book Mobile Service
                    </Button>
                  </Link>
                  <a href="tel:4438000348">
                    <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-secondary text-xs md:text-base py-2 md:py-3 px-4 md:px-6">
                      <i className="ri-phone-line mr-1 md:mr-2"></i>
                      Call Now
                    </Button>
                  </a>
                </div>
              </div>
              <div className="relative">
                <img
                  src="https://public.readdy.ai/ai/img_res/d9eba84ae8f09b4eebd8f75ea1938b20.jpg"
                  alt="Mobile Window Tinting Service"
                  className="rounded-2xl shadow-2xl"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-8 md:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ScrollAnimation animation="fade-in">
              <div className="text-center mb-8 md:mb-16">
                <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-secondary mb-2 md:mb-4">
                  Why Choose Mobile Tinting?
                </h2>
                <p className="text-sm md:text-xl text-gray-600 max-w-3xl mx-auto">
                  Convenience meets quality. Get professional window tinting without leaving your location.
                </p>
              </div>
            </ScrollAnimation>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
              {benefits.map((benefit, index) => (
                <ScrollAnimation key={benefit.title} animation="slide-up" delay={index * 100}>
                  <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-4 md:p-6 border border-gray-200 hover:border-primary hover:shadow-xl transition-all duration-300">
                    <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mb-2 md:mb-4">
                      <i className={`${benefit.icon} text-white text-xl md:text-3xl`}></i>
                    </div>
                    <h3 className="text-base md:text-xl font-bold text-secondary mb-1.5 md:mb-3">{benefit.title}</h3>
                    <p className="text-xs md:text-base text-gray-600 leading-relaxed">{benefit.description}</p>
                  </div>
                </ScrollAnimation>
              ))}
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="py-8 md:py-24 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ScrollAnimation animation="fade-in">
              <div className="text-center mb-8 md:mb-16">
                <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-secondary mb-2 md:mb-4">
                  How Mobile Tinting Works
                </h2>
                <p className="text-sm md:text-xl text-gray-600 max-w-3xl mx-auto">
                  Simple, convenient, and professional. Here's what to expect.
                </p>
              </div>
            </ScrollAnimation>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-8">
              {[
                {
                  step: '1',
                  title: 'Schedule',
                  description: 'Call or book online. Choose a time and location that works for you.',
                  icon: 'ri-calendar-check-line',
                },
                {
                  step: '2',
                  title: 'We Arrive',
                  description: 'Our mobile unit arrives with all equipment and premium tint materials.',
                  icon: 'ri-truck-line',
                },
                {
                  step: '3',
                  title: 'Installation',
                  description: 'Expert installation at your location. Takes 2-4 hours for most vehicles.',
                  icon: 'ri-tools-line',
                },
                {
                  step: '4',
                  title: 'Enjoy',
                  description: 'Drive away with professionally tinted windows and lifetime warranty.',
                  icon: 'ri-star-smile-line',
                },
              ].map((step, index) => (
                <ScrollAnimation key={step.step} animation="slide-up" delay={index * 100}>
                  <div className="relative">
                    <div className="text-center">
                      <div className="w-12 h-12 md:w-20 md:h-20 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4 relative z-10">
                        <i className={`${step.icon} text-white text-xl md:text-3xl`}></i>
                      </div>
                      <div className="absolute top-6 md:top-10 left-1/2 w-full h-0.5 bg-gradient-to-r from-primary to-accent -z-0 hidden md:block" style={{ display: index === 3 ? 'none' : 'block' }}></div>
                      <div className="text-3xl md:text-5xl font-bold text-gray-100 mb-1 md:mb-2">{step.step}</div>
                      <h3 className="text-base md:text-xl font-bold text-secondary mb-1.5 md:mb-3">{step.title}</h3>
                      <p className="text-xs md:text-base text-gray-600 leading-relaxed">{step.description}</p>
                    </div>
                  </div>
                </ScrollAnimation>
              ))}
            </div>
          </div>
        </section>

        {/* Service Areas */}
        <section className="py-8 md:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ScrollAnimation animation="fade-in">
              <div className="text-center mb-8 md:mb-16">
                <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-secondary mb-2 md:mb-4">
                  Service Areas
                </h2>
                <p className="text-sm md:text-xl text-gray-600 max-w-3xl mx-auto">
                  We proudly serve Baltimore and surrounding areas. Don't see your location? Give us a call!
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation animation="slide-up">
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-4 max-w-5xl mx-auto">
                {serviceAreas.map((area, index) => (
                  <div
                    key={area}
                    className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-lg p-2 md:p-4 text-center hover:border-primary hover:shadow-lg transition-all duration-300"
                  >
                    <i className="ri-map-pin-line text-primary text-lg md:text-2xl mb-1 md:mb-2 w-5 h-5 md:w-6 md:h-6 flex items-center justify-center mx-auto"></i>
                    <span className="font-semibold text-secondary whitespace-nowrap text-xs md:text-base">{area}</span>
                  </div>
                ))}
              </div>
            </ScrollAnimation>

            <ScrollAnimation animation="fade-in">
              <div className="mt-6 md:mt-12 text-center">
                <p className="text-xs md:text-base text-gray-600 mb-2 md:mb-4">Additional travel fees may apply for locations outside Baltimore County</p>
                <a href="tel:4438000348" className="text-primary font-semibold hover:text-accent transition-colors whitespace-nowrap text-xs md:text-base">
                  <i className="ri-phone-line mr-1 md:mr-2"></i>
                  Call to confirm service in your area
                </a>
              </div>
            </ScrollAnimation>
          </div>
        </section>

        {/* Fleet Services */}
        <section className="py-8 md:py-24 bg-gradient-to-br from-secondary to-gray-800 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 items-center">
              <ScrollAnimation animation="slide-in-left">
                <div>
                  <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-3 md:mb-6">
                    Fleet & Business Services
                  </h2>
                  <p className="text-sm md:text-xl text-gray-300 mb-4 md:mb-8 leading-relaxed">
                    Perfect for businesses with multiple vehicles. We offer special pricing and scheduling for fleet services.
                  </p>
                  <div className="space-y-2 md:space-y-4 mb-4 md:mb-8">
                    {[
                      'Volume discounts available',
                      'Flexible scheduling for minimal downtime',
                      'Consistent quality across all vehicles',
                      'Dedicated account management',
                      'Invoice billing options',
                      'Same-day service for urgent needs',
                    ].map((feature) => (
                      <div key={feature} className="flex items-center space-x-2 md:space-x-3">
                        <i className="ri-check-line text-accent text-base md:text-xl w-4 h-4 md:w-5 md:h-5 flex items-center justify-center"></i>
                        <span className="text-xs md:text-lg">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <Link to="/contact">
                    <Button size="lg" className="text-xs md:text-base py-2 md:py-3 px-4 md:px-6">
                      <i className="ri-building-line mr-1 md:mr-2"></i>
                      Request Fleet Quote
                    </Button>
                  </Link>
                </div>
              </ScrollAnimation>
              <ScrollAnimation animation="slide-in-right">
                <img
                  src="https://readdy.ai/api/search-image?query=fleet-of-commercial-vehicles-with-professional-window-tinting-business-vans-and-trucks-parked-in-row-modern-corporate-setting-high-quality-automotive-photography&width=800&height=600&seq=fleet1&orientation=landscape"
                  alt="Fleet Services"
                  className="rounded-2xl shadow-2xl"
                />
              </ScrollAnimation>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-8 md:py-24 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <ScrollAnimation animation="fade-in">
              <div className="text-center mb-8 md:mb-16">
                <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-secondary mb-2 md:mb-4">
                  Frequently Asked Questions
                </h2>
                <p className="text-sm md:text-xl text-gray-600">
                  Everything you need to know about mobile tinting
                </p>
              </div>
            </ScrollAnimation>

            <div className="space-y-2 md:space-y-4">
              {faqs.map((faq, index) => (
                <ScrollAnimation key={index} animation="slide-up" delay={index * 50}>
                  <details className="bg-white rounded-xl shadow-md overflow-hidden group">
                    <summary className="px-4 md:px-6 py-3 md:py-5 cursor-pointer list-none flex items-center justify-between hover:bg-gray-50 transition-colors">
                      <h3 className="text-sm md:text-lg font-semibold text-secondary pr-4">{faq.question}</h3>
                      <i className="ri-arrow-down-s-line text-xl md:text-2xl text-primary group-open:rotate-180 transition-transform w-5 h-5 md:w-6 md:h-6 flex items-center justify-center flex-shrink-0"></i>
                    </summary>
                    <div className="px-4 md:px-6 pb-3 md:pb-5 text-xs md:text-base text-gray-600 leading-relaxed">
                      {faq.answer}
                    </div>
                  </details>
                </ScrollAnimation>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-8 md:py-24 bg-gradient-to-br from-primary to-accent text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <ScrollAnimation animation="fade-in">
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-3 md:mb-6">
                Ready for Mobile Service?
              </h2>
              <p className="text-sm md:text-xl mb-4 md:mb-8 opacity-90">
                Book your mobile tinting appointment today. We'll come to you!
              </p>
              <div className="flex flex-col sm:flex-row gap-2 md:gap-4 justify-center">
                <Link to="/contact">
                  <Button size="lg" variant="secondary" className="min-w-[160px] md:min-w-[200px] text-xs md:text-base py-2 md:py-3">
                    <i className="ri-calendar-line mr-1 md:mr-2"></i>
                    Schedule Now
                  </Button>
                </Link>
                <a href="tel:4438000348">
                  <Button size="lg" variant="outline" className="min-w-[160px] md:min-w-[200px] border-white text-white hover:bg-white hover:text-primary text-xs md:text-base py-2 md:py-3">
                    <i className="ri-phone-line mr-1 md:mr-2"></i>
                    (443) 800-0348
                  </Button>
                </a>
              </div>
            </ScrollAnimation>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
